// extracted by mini-css-extract-plugin
export default {"p":"OPDropdown_p__iJyrE","service":"OPDropdown_service__IRHFW"};